export const changeDocumentTitle = (title: string) => {
  document.title = title;
};
